import type { WsEvent } from '@fixflow/shared-types';
import { cartLineLabel, computeCartTotals, itemDiscountValue, itemLineTotal } from './cart-math.js';
import type { PosCartDiscount, PosCartItem, PosCustomerSelection } from './types.js';

export function buildPosDisplayEvent(params: {
  items: PosCartItem[];
  customer: PosCustomerSelection | null;
  cartDiscount: PosCartDiscount | null;
  taxRate: number;
  taxMode: 'parts_only' | 'all' | 'none';
  storeName: string;
}): WsEvent {
  const { items, customer, cartDiscount, taxRate, taxMode, storeName } = params;
  const totals = computeCartTotals(items, cartDiscount, taxRate, taxMode);
  const customerName = customer
    ? `${customer.firstName} ${customer.lastName ?? ''}`.trim()
    : null;

  return {
    type: 'display.update',
    payload: {
      mode: 'review',
      isPosCart: true,
      ticketNumber: null,
      storeName,
      customerName,
      taxRate,
      services: [],
      items: items.map((item) => ({
        id: item.id,
        description: cartLineLabel(item),
        quantity: item.quantity,
        unitPrice: item.unitPrice,
        discountAmount: itemDiscountValue(item),
        lineTotal: String(itemLineTotal(item)),
      })),
      subtotal: totals.subtotal,
      discountTotal: totals.youSaved,
      discountReason: cartDiscount?.reason ?? null,
      taxTotal: totals.tax,
      total: totals.total,
    },
    timestamp: new Date().toISOString(),
  };
}
